import { render } from "./ProjectDetailsList.vue?vue&type=template&id=035dca81"
import script from "./ProjectDetailsList.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__